<script>
export default {
  name: 'AoikumoReadOnlyBanner',
  props: {
    message: {
      type: String,
      default: '',
    },
  },
};
</script>

<template>
  <div
    class="mb-3 py-1.5 px-3 rounded-md bg-blue-50 dark:bg-blue-900/20 text-xs text-blue-800 dark:text-blue-200 flex items-center gap-1.5"
  >
    <fluent-icon icon="info" size="14" />
    <span>{{ message || $t('AOIKUMO_READ_ONLY.BANNER_MESSAGE') }}</span>
  </div>
</template>
